const ZDANIA70 = [
  {
    name: "[7 klasa] Ang Wrzesień 2024",
    lang: 'en',
    zdania: [
      {
        pl: "sąsiedztwo",
        de: "neighborhood",
      },
      {
        pl: "uczciwość, szczerość",
        de: "honesty",
      },
      {
        pl: "niewolnik",
        de: "slave",
      },
      {
        pl: "niewolnictwo",
        de: "slavery",
      },
      {
        pl: "narkomania",
        de: "drug abuse",
      },
      {
        pl: "broń",
        de: "weapon",
      },
      {
        pl: "wspólny, popularny, powszechny",
        de: "common",
      },
      {
        pl: "obraźliwy",
        de: "offensive",
      },
      {
        pl: "obrażać",
        de: "to offend",
      },
      {
        pl: "wyłonić się, pochodzić z",
        de: "emerge from",
      },
      {
        pl: "rytm",
        de: "rhythm",
      },
      {
        pl: "pomimo czegoś ...",
        de: "in spite of",
      },
      {
        pl: "pomimo czegoś ... (bardziej formalnie)",
        de: "despite",
      },
      {
        pl: "bieda",
        de: "poverty",
      },
      {
        pl: "biedny",
        de: "poor",
      },
      {
        pl: "sława",
        de: "fame",
      },
      {
        pl: "słwany",
        de: "famous",
      },
      {
        pl: "zrezygnować, porzucić, odpaść",
        de: "to drop out",
      },
      {
        pl: "wejśc z przytupem, przebić się",
        de: "get a foot into",
      },
      {
        pl: "pogrzeb",
        de: "funeral",
      },
      {
        pl: "przeważnie, głównie",
        de: "predominantly",
      },
      {
        pl: "żywiołowy, pełny energii",
        de: "exuberant",
      },
      {
        pl: "puzon",
        de: "trombone",
      },
      {
        pl: "nieporozumienie",
        de: "misunderstanding",
      },
      {
        pl: "w porównaniu do",
        de: "in comparison to",
      },
      {
        pl: "rozrywka",
        de: "entertainment",
      },
      {
        pl: "pochodzić",
        de: "orginate",
      },
      {
        pl: "cecha, funkcjonalnosc",
        de: "feature",
      },
    ],
  },
];

const ZDANIA71 = [
  {
    name: "[7 klasa] Ang Październik 2024",
    lang: 'en',
    zdania: [
      {
        pl: "chrupiący",
        de: "crisp",
      },

      {
        pl: "utrzymywać",
        de: "maintain",
      },

      {
        pl: "dodatek",
        de: "addition",
      },

      {
        pl: "różnorodność",
        de: "variety",
      },

      {
        pl: "listy przebojów",
        de: "charts",
      },

      {
        pl: "bez wysiłku",
        de: "effortlessly",
      },

      {
        pl: "unikatowy",
        de: "distinctive",
      },

      {
        pl: "wyróżniać",
        de: "feature",
      },

      {
        pl: "cudowny",
        de: "marvellous",
      },

      {
        pl: "wspaniale",
        de: "superbly",
      },

      {
        pl: "ryk",
        de: "roar",
      },

      {
        pl: "huknąć",
        de: "crash",
      },

      {
        pl: "syczeć",
        de: "hiss",
      },

      {
        pl: "wyć",
        de: "howl",
      },

      {
        pl: "szczekać",
        de: "bark",
      },

      {
        pl: "warczeć, chrząkać",
        de: "grunt",
      },

      {
        pl: "plusk",
        de: "splash",
      },

      {
        pl: "huk/trzask",
        de: "bang",
      },

      {
        pl: "skrzypieć",
        de: "creak",
      },

      {
        pl: "mruczeć pod nosem",
        de: "hum",
      },

      {
        pl: "gwizdać",
        de: "whistle",
      },

      {
        pl: "rechotać",
        de: "croak",
      },

      {
        pl: "melodie wpadające w ucho",
        de: "catchy tunes",
      },

      {
        pl: "zespół muzyczny",
        de: "band",
      },

      {
        pl: "okładka",
        de: "cover",
      },

      {
        pl: "album",
        de: "album",
      },
      {
        pl: "uprawiać (np. ziemię)",
        de: "cultivate",
      },
      {
        pl: "stromy",
        de: "steep",
      },
      {
        pl: "błotnisty",
        de: "muddy",
      },
      {
        pl: "szeroki",
        de: "wide",
      },
      {
        pl: "shallow",
        de: "płtyki",
      },
      {
        pl: "prosty / wyprostowany / bezpośredni",
        de: "straight",
      },
      {
        pl: "czysty / jasny / wyraźny",
        de: "clear",
      },
      {
        pl: "łagdony / delikatny",
        de: "gentle",
      },
      {
        pl: "wąski",
        de: "narrow",
      },
      {
        pl: "dziki",
        de: "wild",
      },
      {
        pl: "kręcony / uzwojony / nawijany",
        de: "winding",
      },
      {
        pl: "wąsko-myślący / ograniczony umysłowo",
        de: "narrow-minded",
      },
      {
        pl: "kamienista trawa",
        de: "pennle beach",
      },
      {
        pl: "strumień świadomości",
        de: "a stream of consciousness",
      },
      {
        pl: "lasy",
        de: "forests",
      },
      {
        pl: "sady",
        de: "orchards",
      },
      {
        pl: "stoki",
        de: "slopes",
      },
      {
        pl: "szczyty",
        de: "peaks",
      },
      {
        pl: "strumienie",
        de: "streams",
      },
      {
        pl: "ściezki",
        de: "paths",
      },
      {
        pl: "doliny",
        de: "valleys",
      },
      {
        pl: "rzeka",
        de: "river",
      },
      {
        pl: "kanal (np. rzeki)",
        de: "cannal",
      },
      {
        pl: "powódz/ zalanie",
        de: "flood",
      },
      {
        pl: "drewno (jako materiał)",
        de: "wood",
      },
      {
        pl: "belki, deski",
        de: "timber",
      },
      {
        pl: "góry",
        de: "mountains",
      },
      {
        pl: "klif",
        de: "cliff",
      },
      {
        pl: "wzórze",
        de: "hill",
      },
      {
        pl: "jaskinia",
        de: "cave",
      },
      {
        pl: "brzeg (rzeki lub jeziora)",
        de: "bank",
      },
      {
        pl: "plaza",
        de: "beach",
      },
      {
        pl: "wybrzeze (morza / oceanu)",
        de: "shore",
      },
      {
        pl: "zatoka",
        de: "coast",
      },
      {
        pl: "piasek",
        de: "sand",
      },
      {
        pl: "gleba / ziemia",
        de: "soil",
      },
      {
        pl: "pył / kurz",
        de: "dust",
      },
      {
        pl: "błoto",
        de: "mud",
      },
      {
        pl: "sea",
        de: "morze",
      },
      {
        pl: "ocean",
        de: "ocean",
      },
      {
        pl: "jezioro",
        de: "lake",
      },
      {
        pl: "wodospad",
        de: "waterfall",
      },
    ],
  },
];

const ZDANIA73 = [
  {
    name: "[7 klasa] Niemiecki Marzec 2025",
    lang: 'de',
    zdania: [
      {
        pl: "Zawsze nosisz czapkę?",
        de: "Trägst du immer eine Mütze?",
      },
      {
        pl: "Podoba mi się ten kapelusz.",
        de: "Mir gefällt dieser Hut.",
      },
      {
        pl: "Muszę kupić nowe rękawiczki.",
        de: "Ich muss neue Handschuhe kaufen.",
      },
      {
        pl: "Weź szalik, jest zimno.",
        de: "Nimm den Schal, ist ja kalt.",
      },
      {
        pl: "Ten sweter jest bardzo ciepły.",
        de: "Der Pullover ist sehr warm.",
      },
      {
        pl: "Potrzebny ci pasek.",
        de: "Du brauchst einen Gürtel.",
      },
      {
        pl: "Gdzie jest moja torba? Leży tam.",
        de: "Wo ist meine Tasche? Sie liegt dort.",
      },
      {
        pl: "Miałam katar, więc dał mi chusteczkę higieniczną.",
        de: "Ich hatte Schnupfen, darum gab er mir ein Taschentuch.",
      },
      {
        pl: "Moja matka zawsze miała na szyi łańcuszek.",
        de: "Meine Mutter hatte immer eine Kette um den Hals.",
      },
      {
        pl: "Ona dostała bardzo ładne, złote kolczyki od swojego chłopaka.",
        de: "Sie hat sehr schöne, goldene Ohrringe von ihm bekommen.",
      },
      {
        pl: "Ona zawsze nosi pierścionek.",
        de: "Sie trägt immer einen Ring.",
      },
      {
        pl: "Możesz zabrać parasol?",
        de: "Kannst du den Regenschirm mitnehmen?",
      },
      {
        pl: "Jest zimno, więc zakładam kozaki.",
        de: "Es ist kalt, also ziehe ich meine Stiefel an.",
      },
      {
        pl: "Czy ubierasz płaszcz przeciwdeszczowy, gdy pada deszcz?",
        de: "Ziehst du den Regenmantel an, wenn es regnet?",
      },
      {
        pl: "Noszę okulary.",
        de: "Ich trage eine Brille.",
      },
      {
        pl: "Uważam, że sandały są bardzo wygodne.",
        de: "Ich finde Sandalen sehr bequem.",
      },
      {
        pl: "W tym kostiumie kąpielowym wyglądasz świetnie.",
        de: "In diesem Badeanzug siehst du wirklich super aus.",
      },
      {
        pl: "Idziemy pływać. Weź swoje kąpielówki.",
        de: "Wir gehen schwimmen. Nimm deine Badehose mit.",
      },
      {
        pl: "Zawsze noszę okulary przeciwsłoneczne, gdy świeci słońce.",
        de: "Ich trage immer eine Sonnenbrille, wenn die Sonne scheint.",
      },
      {
        pl: "Ten ręcznik pachnie świeżo.",
        de: "Dieses Handtuch riecht frisch.",
      },
      {
        pl: "Moda mnie nie interesuje.",
        de: "Mode interessiert mich nicht.",
      },
      {
        pl: "Bardzo łatwo mnie znajdziesz. Mam na sobie żółtą kurtkę.",
        de: "Du findest mich ganz einfach. Ich habe die gelbe Jacke an.",
      },
      {
        pl: "Te spodnie nie pasują do tej koszuli.",
        de: "Die Hose passt nicht zu dem Hemd.",
      }
    ]
  }
];


const ZDANIA74 = [
  {
    name: "[Angielski słówka ze skanu - pełna wersja]",
    lang: 'en',
    zdania: [
      { pl: "She is (adres)", de: "address" },
      { pl: "She is (data urodzenia)", de: "date of birth" },
      { pl: "She is (kobieta)", de: "female" },
      { pl: "She is (imię)", de: "first name" },
      { pl: "She is (mężczyzna)", de: "male" },
      { pl: "She is (stan cywilny)", de: "marital status" },
      { pl: "She is (żonaty / mężatka)", de: "married" },
      { pl: "She is (narodowość)", de: "nationality" },
      { pl: "She is (zawód)", de: "occupation" },
      { pl: "She is (paszport)", de: "passport" },
      { pl: "She is (dane osobowe)", de: "personal details" },
      { pl: "She is (miejsce urodzenia)", de: "place of birth" },
      { pl: "She is (płeć)", de: "sex" },
      { pl: "She is (singiel / panna / kawaler)", de: "single" },
      { pl: "She is (nazwisko)", de: "surname" },
      { pl: "She is (wdowa)", de: "widow" },
      { pl: "She is (wdowiec)", de: "widower" },
      { pl: "She is (wygląd)", de: "appearance" },
      { pl: "She is (piękny)", de: "beautiful" },
      { pl: "She is (blondyn / blondynka)", de: "blond(e)" },
      { pl: "She is (kręcone)", de: "curly" },
      { pl: "She is (ciemne)", de: "dark" },
      { pl: "She is (gruby)", de: "fat" },
      { pl: "She is (atrakcyjny)", de: "good-looking" },
      { pl: "She is (przystojny)", de: "handsome" },
      { pl: "She is (wzrost)", de: "height" },
      { pl: "She is (w wieku 20–23 lat)", de: "in his/her early twenties" },
      { pl: "She is (w wieku 24–26 lat)", de: "in his/her mid twenties" },
      { pl: "She is (w wieku 27–29 lat)", de: "in his/her late twenties" },
      { pl: "She is (w średnim wieku)", de: "middle-aged" },
      { pl: "She is (średniego wzrostu)", de: "of medium height" },
      { pl: "She is (stary)", de: "old" },
      { pl: "She is (z nadwagą)", de: "overweight" },
      { pl: "She is (pospolity)", de: "plain" },
      { pl: "She is (ładna)", de: "pretty" },
      { pl: "She is (niski)", de: "short" },
      { pl: "She is (szczupły)", de: "slim" },
      { pl: "She is (proste (włosy))", de: "straight" },
      { pl: "She is (wysoki)", de: "tall" },
      { pl: "She is (chudy)", de: "thin" },
      { pl: "She is (brzydki)", de: "ugly" },
      { pl: "She is (waga)", de: "weight" },
      { pl: "She is (dobrze zbudowany)", de: "well-built" },
      { pl: "She is (młody)", de: "young" },
      { pl: "She is (łysy)", de: "bald" },
      { pl: "She is (broda)", de: "beard" },
      { pl: "She is (czarne)", de: "black" },
      { pl: "She is (jasne)", de: "fair" },
      { pl: "She is (rude)", de: "ginger" },
      { pl: "She is (siwe)", de: "grey" },
      { pl: "She is (wąsy)", de: "moustache" },
      { pl: "She is (czerwone / rude)", de: "red" },
      { pl: "She is (falowane)", de: "wavy" },
      { pl: "She is (codzienny, swobodny)", de: "casual" },
      { pl: "She is (modny)", de: "fashionable" },
      { pl: "She is (oficjalny)", de: "formal" },
      { pl: "She is (staromodny)", de: "old-fashioned" },
      { pl: "She is (niechlujny)", de: "scruffy" },
      { pl: "She is (elegancki)", de: "smart" },
      { pl: "She is (strój sportowy)", de: "sportswear" },
      { pl: "She is (modny, na czasie)", de: "trendy" },
      { pl: "She is (guzik)", de: "button" },
      { pl: "She is (kołnierzyk)", de: "collar" },
      { pl: "She is (kieszeń)", de: "pocket" },
      { pl: "She is (rękaw)", de: "sleeve" },
      { pl: "She is (zamek błyskawiczny)", de: "zip" },
      { pl: "She is (bawełna)", de: "cotton" },
      { pl: "She is (dżins)", de: "denim" },
      { pl: "She is (skóra)", de: "leather" },
      { pl: "She is (len)", de: "linen" },
      { pl: "She is (gładki)", de: "plain" },
      { pl: "She is (jedwab)", de: "silk" },
      { pl: "She is (w kropki)", de: "spotted" },
      { pl: "She is (w paski)", de: "striped" },
      { pl: "She is (wełniany)", de: "woollen" },
      { pl: "She is (bluzka)", de: "blouse" },
      { pl: "She is (płaszcz)", de: "coat" },
      { pl: "She is (sukienka)", de: "dress" },
      { pl: "She is (kurtka, marynarka)", de: "jacket" },
      { pl: "She is (dżinsy)", de: "jeans" },
      { pl: "She is (sweter)", de: "jumper" },
      { pl: "She is (legginsy)", de: "leggings" },
      { pl: "She is (koszula)", de: "shirt" },
      { pl: "She is (spodenki)", de: "shorts" },
      { pl: "She is (spódnica)", de: "skirt" },
      { pl: "She is (garnitur)", de: "suit" },
      { pl: "She is (bluza)", de: "sweatshirt" },
      { pl: "She is (koszulka)", de: "T-shirt" },
      { pl: "She is (top / bluzka)", de: "top" },
      { pl: "She is (dres)", de: "tracksuit" },
      { pl: "She is (spodnie)", de: "trousers" },
      { pl: "She is (buty (wysokie))", de: "boots" },
      { pl: "She is (klapki japonki)", de: "flip-flops" },
      { pl: "She is (buty na obcasie)", de: "high heels" },
      { pl: "She is (buty)", de: "shoes" },
      { pl: "She is (kapcie)", de: "slippers" },
      { pl: "She is (skarpetki)", de: "socks" },
      { pl: "She is (sandały)", de: "sandals" },
      { pl: "She is (adidasy, buty sportowe)", de: "trainers" },
      { pl: "She is (pasek)", de: "belt" },
      { pl: "She is (bransoletka)", de: "bracelet" },
      { pl: "She is (kolczyki)", de: "earrings" },
      { pl: "She is (okulary)", de: "glasses" },
      { pl: "She is (rękawiczki)", de: "gloves" },
      { pl: "She is (torebka)", de: "handbag" },
      { pl: "She is (kapelusz, czapka)", de: "hat" },
      { pl: "She is (naszyjnik)", de: "necklace" },
      { pl: "She is (portmonetka)", de: "purse" },
      { pl: "She is (pierścionek)", de: "ring" },
      { pl: "She is (szalik / apaszka)", de: "scarf" },
      { pl: "She is (krawat)", de: "tie" },
      { pl: "She is (parasolka)", de: "umbrella" },
      { pl: "She is (ambitny)", de: "ambitious" },
      { pl: "She is (apodyktyczny)", de: "bossy" },
      { pl: "She is (odważny)", de: "brave" },
      { pl: "She is (spokojny)", de: "calm" },
      { pl: "She is (nieostrożny)", de: "careless" },
      { pl: "She is (opiekuńczy)", de: "caring" },
      { pl: "She is (radosny)", de: "cheerful" },
      { pl: "She is (mądry, sprytny)", de: "clever" },
      { pl: "She is (pewny siebie)", de: "confident" },
      { pl: "She is (nieuczciwy)", de: "dishonest" },
      { pl: "She is (wyluzowany)", de: "easygoing" },
      { pl: "She is (przyjacielski)", de: "friendly" },
      { pl: "She is (zabawny)", de: "funny" },
      { pl: "She is (hojny)", de: "generous" },
      { pl: "She is (pracowity)", de: "hard-working" },
      { pl: "She is (pomocny)", de: "helpful" },
      { pl: "She is (uczciwy)", de: "honest" },
      { pl: "She is (niecierpliwy)", de: "impatient" },
      { pl: "She is (niegrzeczny)", de: "impolite" },
      { pl: "She is (uprzejmy, miły)", de: "kind" },
      { pl: "She is (leniwy)", de: "lazy" },
      { pl: "She is (skąpy, złośliwy)", de: "mean" },
      { pl: "She is (bałaganiarski)", de: "messy" },
      { pl: "She is (humorzasty)", de: "moody" },
      { pl: "She is (nerwowy)", de: "nervous" },
      { pl: "She is (grzeczny)", de: "polite" },
      { pl: "She is (cichy)", de: "quiet" },
      { pl: "She is (niezawodny)", de: "reliable" },
      { pl: "She is (samolubny)", de: "selfish" },
      { pl: "She is (nieśmiały)", de: "shy" },
      { pl: "She is (głupiutki)", de: "silly" },
      { pl: "She is (towarzyski)", de: "sociable" },
      { pl: "She is (uparty)", de: "stubborn" },
      { pl: "She is (gadatliwy)", de: "talkative" },
      { pl: "She is (schludny)", de: "tidy" },
      { pl: "She is (nieuprzejmy)", de: "unkind" },
      { pl: "She is (niechlujny)", de: "untidy" },
      { pl: "She is (zdumiony)", de: "amazed" },
      { pl: "She is (zły)", de: "angry" },
      { pl: "She is (zirytowany)", de: "annoyed" },
      { pl: "She is (znudzony)", de: "bored" },
      { pl: "She is (zmieszany)", de: "confused" },
      { pl: "She is (zagniewany)", de: "cross" },
      { pl: "She is (zachwycony)", de: "delighted" },
      { pl: "She is (przygnębiony)", de: "depressed" },
      { pl: "She is (rozczarowany)", de: "disappointed" },
      { pl: "She is (zawstydzony)", de: "embarrassed" },
      { pl: "She is (podekscytowany)", de: "excited" },
      { pl: "She is (przestraszony)", de: "frightened" },
      { pl: "She is (zainteresowany)", de: "interested" },
      { pl: "She is (samotny)", de: "lonely" },
      { pl: "She is (zdenerwowany)", de: "nervous" },
      { pl: "She is (zrelaksowany)", de: "relaxed" },
      { pl: "She is (smutny)", de: "sad" },
      { pl: "She is (zszokowany)", de: "shocked" },
      { pl: "She is (zaskoczony)", de: "surprised" },
      { pl: "She is (zmęczony)", de: "tired" },
      { pl: "She is (zasmucony, zdenerwowany)", de: "upset" },
      { pl: "She is (zmartwiony)", de: "worried" },
      { pl: "You should (bać się czegoś)", de: "be afraid of sth" },
      { pl: "You should (interesować się czymś)", de: "be interested in sth" },
      { pl: "You should (lubić coś)", de: "be keen on sth" },
      { pl: "You should (szaleć na punkcie czegoś)", de: "be mad about sth" },
      { pl: "She is (nie móc czegoś znieść)", de: "can’t stand sth" },
      { pl: "He wants to (ćwiczyć)", de: "do exercise" },
      { pl: "He wants to (uprawiać sport)", de: "do sport" },
      { pl: "He wants to (ćwiczyć jogę)", de: "do yoga" },
      { pl: "He wants to (chodzić tańczyć)", de: "go dancing" },
      { pl: "He wants to (biegać)", de: "go running" },
      { pl: "He wants to (chodzić na zakupy)", de: "go shopping" },
      { pl: "He wants to (jeździć na deskorolce)", de: "go skateboarding" },
      { pl: "He wants to (pływać)", de: "go swimming" },
      { pl: "She is (spędzać czas z przyjaciółmi)", de: "hang out with friends" },
      { pl: "She is (nienawidzić czegoś)", de: "hate sth" },
      { pl: "She is (lubić coś)", de: "like sth" },
      { pl: "She is (kochać coś)", de: "love sth" },
      { pl: "He wants to (grać w szachy)", de: "play chess" },
      { pl: "He wants to (grać w gry komputerowe)", de: "play computer games" },
      { pl: "He wants to (grać w piłkę nożną)", de: "play football" },
      { pl: "He wants to (grać na gitarze)", de: "play the guitar" },
      { pl: "We like to (woleć coś od czegoś)", de: "prefer sth to sth" },
      { pl: "He wants to (czytać książki)", de: "read books" },
      { pl: "He wants to (czytać czasopisma)", de: "read magazines" },
      { pl: "We like to (spędzać czas samemu)", de: "spend time alone" },
      { pl: "We like to (spędzać czas z przyjaciółmi)", de: "spend time with friends" },
      { pl: "He wants to (oglądać telewizję)", de: "watch TV" },
      { pl: "He wants to (pisać bloga)", de: "write a blog" },
      { pl: "You should (być fanem kogoś/czegoś)", de: "be a fan of sb/sth" },
      { pl: "You should (interesować się czymś)", de: "be into sth" },
      { pl: "You should (być częścią czyjejś natury)", de: "be part of sb’s nature" },
      { pl: "She is (nie móc się powstrzymać od robienia czegoś)", de: "can’t help doing sth" },
      { pl: "She is (zmienić zdanie)", de: "change your mind" },
      { pl: "She is (rozmawiać z przyjaciółmi online)", de: "chat online with friends" },
      { pl: "He wants to (pracować jako wolontariusz)", de: "do voluntary work" },
      { pl: "She is (jeść poza domem)", de: "eat out" },
      { pl: "We like to (wyrażać swoje poglądy)", de: "express sb’s views" },
      { pl: "They will (pokłócić się z kimś)", de: "fall out with sb" },
      { pl: "We like to (mieć ochotę coś zrobić)", de: "feel like doing sth" },
      { pl: "They will (dobrze się z kimś dogadywać)", de: "get on well with sb" },
      { pl: "He wants to (wychodzić)", de: "go out" },
      { pl: "They will (bawić się jak nigdy)", de: "have the time of your life" },
      { pl: "She is (fanatyk zdrowego stylu życia)", de: "health nut" },
      { pl: "We like to (patrzeć na jasną stronę)", de: "look on the bright side" },
      { pl: "They will (robić różnicę / mieć znaczenie)", de: "make a difference" },
      { pl: "They will (zawierać nowe znajomości)", de: "make new friends" },
      { pl: "He wants to (grać na instrumencie muzycznym)", de: "play a musical instrument" },
      { pl: "He wants to (grać w karty)", de: "play cards" },
      { pl: "We like to (woleć zajęcia w pomieszczeniach)", de: "prefer indoor activities" },
      { pl: "We like to (woleć zajęcia na świeżym powietrzu)", de: "prefer outdoor activities" },
      { pl: "We like to (woleć sporty drużynowe)", de: "prefer team sports" },
      { pl: "We like to (wspierać organizację charytatywną)", de: "support a charity" },
      { pl: "They will (brać udział w)", de: "take part in" },
      { pl: "They will (zacząć hobby)", de: "take up a hobby" },
      { pl: "She is (rozmawiać o problemach)", de: "talk about problems" },
      { pl: "She is (ten, który nie pasuje do reszty)", de: "the odd one out" },
      { pl: "She is (chleb razowy)", de: "wholemeal bread" },
      { pl: "She is (szerokie zainteresowania)", de: "wide interests" }
    ]
  }
]

const ZDANIA75 = [
  {
    name: "[Angielski słówka ze skanu2]",
    lang: 'en',
    zdania: [
      { pl: "My (adres) is in London", de: "address" },
      { pl: "What is your (data urodzenia)?", de: "date of birth" },
      { pl: "She is a (kobieta)", de: "female" },
      { pl: "My (imię) is John", de: "first name" },
      { pl: "He is a (mężczyzna)", de: "male" },
      { pl: "What is your (stan cywilny)?", de: "marital status" },
      { pl: "She is (mężatką)", de: "married" },
      { pl: "What is your (narodowość)?", de: "nationality" },
      { pl: "My (zawód) is teacher", de: "occupation" },
      { pl: "Do you have a (paszport)?", de: "passport" },
      { pl: "These are my (dane osobowe)", de: "personal details" },
      { pl: "Dane osobowe", de: "personal data" },
      { pl: "Wdowa", de: "widow" },
      { pl: "Wdowiec", de: "widower" },
      { pl: "She is a (wdowa)", de: "widow" },
      { pl: "He is a (wdowiec)", de: "widower" },
      { pl: "Her (wygląd) is nice", de: "appearance" },
      { pl: "Być średniego wzrostu", de: "be of medium height" },
      { pl: "Wyglądać jak ktoś", de: "look like" },
      { pl: "Pulchny", de: "plump" },
      { pl: "Szczupły", de: "slim" },
      { pl: "Wysoki", de: "tall" },
      
      { pl: "She is (piękna)", de: "beautiful" },
      { pl: "He is (blondyn)", de: "blond(e)" },
      { pl: "She has (kręcone) hair", de: "curly" },
      { pl: "He has (ciemne) hair", de: "dark" },
      { pl: "Być podobnym do kogoś", de: "be similar to sb" },
      { pl: "Opis", de: "description" },
      { pl: "He is (gruby)", de: "fat" },
      { pl: "She is (atrakcyjna)", de: "good-looking" },
      { pl: "Atrakcyjny", de: "attractive" },
      { pl: "He is (przystojny)", de: "handsome" },
      { pl: "Rozwiedziony", de: "divorced" },
      { pl: "Wypełnić formularz", de: "fill in a form" },
      { pl: "Ożenić się", de: "get married" },
      { pl: "Stan cywilny", de: "marital status" },
      { pl: "Żonaty", de: "married" },
      { pl : "Zamężna", de: "married" },
      { pl : "Drugie imię", de: "middle name" },
      { pl: "His (wzrost) is 180 cm", de: "height" },
      { pl: "She is in her (wczesne lata dwudzieste)", de: "in her early twenties" },
      { pl: "He is in his (środkowe lata dwudzieste)", de: "in his mid twenties" },
      { pl: "She is in her (późne lata dwudzieste)", de: "in her late twenties" },
      { pl: "He is (w średnim wieku)", de: "middle-aged" },
      { pl: "She is of (średniego wzrostu)", de: "medium height" },
      { pl: "He is (stary)", de: "old" },
      { pl: "dorosły", de: "adult" },
      { pl: "W podeszłym wieku", de: "elderly" },
      { pl: "He is (szczupły)", de: "fit" },
      { pl: "He has (siwe) hair", de: "grey" },
      { pl: "He is (atletycznej budowy)", de: "muscular" },
      { pl: "Otyły", de: "obese" },
      { pl: "po dwidziestce", de: "in his/hers twenties" },
      { pl: "natostoletni", de: "teenager" },
      { pl: "w średnim wieku", de: "middle-aged" },


      { pl: "She is (z nadwagą)", de: "overweight" },
      { pl: "Her face is (zwyczajna)", de: "plain" },
      { pl: "She is (ładna)", de: "pretty" },
      { pl: "He is (niski)", de: "short" },
      { pl: "She is (szczupła)", de: "slim" },
      { pl: "He has (proste) hair", de: "straight" },
      { pl: "He is (wysoki)", de: "tall" },
      { pl: "She is (chuda)", de: "thin" },
      { pl: "He is (brzydki)", de: "ugly" },
      { pl: "My (waga) is 60 kg", de: "weight" },
      { pl: "Broda", de: "beard" },
      { pl: "piegowaty", de: "freckled" },
      { pl: "piegi", de: "freckles" },
      { pl: "Wąsy", de: "moustache" },
      { pl: "Oczy", de: "eyes" },
      { pl: "pełne usta", de: "full lips" },
      { pl: "wąskie usta", de: "thin lips" },
      { pl: "wysokie czoło", de: "high forehead" },
      { pl: "wąsy", de: "moustache" },
      { pl: "brwi", de: "eyebrows" },
      { pl: "długie rzęsy", de: "long eyelashes" },
      { pl: "blady", de: "pale" },
      { pl: "pryszcz", de: "pimple" },
      { pl: "blizna", de: "scar" },
      { pl: "zadarty nos", de: "snub nose" },
      { pl: "wydatny podbródek", de: "strong chin" },
      { pl: "małe oczy", de: "tiny eyes" },
      { pl: "zmarszczki", de: "wrinkles" },
      { pl: "łysy", de: "bald" },
      { pl: "blond/janse/ciemne/rude/siwe włosy", de: "blond/fair/dark/red/grey hair" },
      { pl: "kręcone/włosy", de: "curly/straight hair" },
      { pl: "farbować włosy", de: "dye your hair" },
      { pl: "grzywka", de: "fringe" },
      { pl: "kucyk", de: "ponytail" },
      { pl: "warkocz", de: "plait" },
      { pl: "stęrczące", de: "spiky" },
      { pl: "kucyk", de: "ponytail" },
      { pl: "fryzura", de: "hairstyle" },
      { pl: "proste włosy", de: "straight hair" },
      { pl: "falowane włosy", de: "wavy hair" },
      { pl: "nieformalny", de: "casual" },
      { pl: "wygodny", de: "comfortable" },
      { pl: "elegancki", de: "smart" },
      { pl: "modny", de: "stylish" },
      { pl: "oficjalny", de: "formal" },
      { pl: "luźny", de: "loose" },
      { pl: "obcisły", de: "tight" },
      { pl: "niechlujny", de: "untidy" },
      { pl: "bluzka", de: "blouse" },
      { pl: "bokserki", de: "boxer shorts" },
      { pl: "plaszcz", de: "coat" },
      { pl: "kurtka", de: "jacket" },
      { pl: "jeansy", de: "jeans" },
      { pl: "koszula", de: "shirt" },
      { pl: "spódnica", de: "skirt" },
      { pl: "bluza z kapturem", de: "hoodie" },
      { pl: "polar", de: "fleece" },
      { pl: "szalik", de: "scarf" },
      { pl: "sweter", de: "sweater" },
      { pl: "para jeansów", de: "a pair of jeans" },
      { pl: "płaszcz przeciwdeszczowy", de: "raincoat" },
      { pl: "szorty", de: "shorts" },
      { pl: "spodnie", de: "trousers" },
      { pl: "krótkie spodenki", de: "shorts" },
      { pl: "garnitur", de: "suit" },
      { pl: "bluza", de: "sweatshirt" },
      { pl: "krawat", de: "tie" },
      { pl: "rajstopy", de: "tights" },
      { pl: "dres", de: "tracksuit" },
      { pl: "spodnie", de: "pants" },
      { pl: "bielizna", de: "underwear" },
      { pl: "buty za kostkę/kozaki", de: "boots" },
      { pl: "buty na wysokim obcasie", de: "high-heels" },
      { pl: "buty sportowe", de: "trainers" },
      { pl: "buty", de: "shoes" },
      { pl: "sandały", de: "sandals" },
      { pl: "kapcie", de: "slippers" },
      { pl: "kalosze", de: "wellies" },
      { pl: "pasek", de: "belt" },
      { pl: "bransoletka", de: "bracelet" },
      { pl: "czapka z daszkiem", de: "cap" },
      { pl: "kolczyki", de: "earrings" },
      { pl: "okulary przeciwsłoneczne", de: "sunglasses" },
      { pl: "rękawiczki", de: "gloves" },
      { pl: "czapka/kapelusz", de: "hat" },
      { pl: "biżuteria", de: "jewellery" },
      { pl: "naszyjnik", de: "necklace" },
      { pl: "zegarek", de: "watch" },
      { pl: "szalik", de: "scarf" },
      { pl: "parasolka", de: "umbrella" },
      { pl: "guzik", de: "button" },
      { pl: "kieszeń", de: "pocket" },
      { pl: "rękaw", de: "sleeve" },
      { pl: "zamek błyskawiczny", de: "zip" },
      { pl: "bawełniany", de: "cotton" },
      { pl: "jeansowy", de: "denim" },
      { pl: "skórzany", de: "leather" },
      { pl: "gładki", de: "plain" },
      { pl: "jedwar", de: "silk" },
      { pl: "wełniany", de: "woollen" },
      { pl: "w kratę", de: "checked" },
      { pl: "ubierać się", de: "dress" },
      { pl: "przebrać sie za coś/kogoś", de: "dress up as sth/sb" },
      { pl: "pasować", de: "fit" },
      { pl: "ubrać się", de: "get dressed" },
      { pl: "pasować do czegoś", de: "go with sth" },
      { pl: "wyglądać dobrze/źle", de: "look good/bad" },
      { pl: "pasować do czegoś", de: "match sth" },
      { pl: "założyć coś", de: "put sth on" },
      { pl: "pasować kolorem lub stylem", de: "suit" },
      { pl: "zdjąć coś", de: "take sth off" },
      { pl: "zdejmować ubrania", de: "undress" },
      { pl: "przymierzać coś", de: "try sth on" },
      { pl: "nosić ubrania", de: "wear clothes" },
      { pl: "ambitny", de: "ambitious" },
      { pl: "nudny", de: "boring" },
      { pl: "odważny", de: "brave" },
      { pl: "uprzejmy", de: "kind" },
      { pl: "spokojny", de: "calm" },
      { pl: "bystry", de: "clever" },
      { pl: "pewny siebie", de: "confident" },
      { pl: "rozważny", de: "considerate" },
      { pl: "kreatywny", de: "creative" },
      { pl: "zdecydowany", de: "descive" },
      { pl: "sprawiedliwy", de: "fair" },
      { pl: "niesprawiedliwy", de: "unfair" },
      { pl: "miły", de: "friendly" },
      { pl: "niemiły", de: "unfriendly" },
      { pl: "szczęśliwy", de: "happy" },
      { pl: "nieszczęśliwy", de: "unhappy" },
      { pl: "uczciwy", de: "honest" },
      { pl: "nieuczciwy", de: "dishonest" },
      { pl: "szczodry", de: "generous" },
      { pl: "skąpy", de: "mean" },
      { pl: "zabawny", de: "funny" },
      { pl: "pracowity", de: "hard-working" },
      { pl: "nieśmiały", de: "shy" },
      { pl: "rozsądny", de: "sensible" },
      { pl: "uczciwy", de: "honest" },
      { pl: "nieuczciwy", de: "dishonest" },
      { pl: "szczodry", de: "generous" },
      { pl: "skąpy", de: "mean" },
      { pl: "zabawny", de: "funny" },
      { pl: "pracowity", de: "hard-working" },
      { pl: "inspirujący", de: "inspiring" },
      { pl: "zyczliwy", de: "kind" },
      { pl: "niezyczliwy", de: "unkind" },
      { pl: "leniwy", de: "lazy" },
      { pl: "lojalny", de: "loyal" },
      { pl: "nielojalny", de: "disloyal" },
      { pl: "niezależny", de: "independent" },
      { pl: "skromny", de: "modest" },
      { pl: "cierpliwy", de: "patient" },
      { pl: "niecierpliwy", de: "impatient" },
      { pl: "uprzejmy", de: "polite" },
      { pl: "nieuprzejmy", de: "impolite" },
      { pl: "praktyczny", de: "practical" },
      { pl: "cicha", de: "quiet" },
      { pl: "odpowiedzialny", de: "responsible" },
      { pl: "nieodpowiedzialny", de: "irresponsible" },
      { pl: "samolubny", de: "selfish" },
      { pl: "wrażliwy", de: "sensitive" },
      { pl: "towarzyski", de: "sociable" },
      { pl: "niespokojny", de: "worried" },
      { pl: "uparty", de: "stubborn" },
      { pl: "rozmowny", de: "talkative" },
      { pl: "schludny", de: "tidy" },
      { pl: "niechlujny", de: "untidy" },
      { pl: "zorganizowany", de: "organized" },
      { pl: "zdumiony", de: "amazed" },
      { pl: "rozbawiony", de: "amused" },
      { pl: "zly", de: "angry" },
      { pl: "rozdrażniony", de: "annoyed" },
      { pl: "znudzony", de: "bored" },
      { pl: "zmartwiony", de: "concerned" },
      { pl: "zdezorientowany", de: "confused" },
      { pl: "przygnębiony", de: "depressed" },
      { pl: "rozczarowany", de: "disappointed" },
      { pl: "zawstydzony", de: "embarrassed" },
      { pl: "podekscytowany", de: "excited" },
      { pl: "wyczerpany", de: "exhausted" },
      { pl: "przestraszony", de: "frightened" },
      { pl: "pełnen nadziei", de: "hopeful" },
      { pl: "przestraszony", de: "nervous" },
      { pl: "zazdrosny", de: "jealous" },
      { pl: "samotny", de: "lonely" },
      { pl: "zadowolony", de: "pleased" },
      { pl: "dumny", de: "proud" },
      { pl: "zestresowany", de: "stressed" },
      { pl: "zdziwiony", de: "surprised" },
      { pl: "bać się czegoś", de: "be afraid of sth" },
      { pl: "być zły na kogoś", de: "be angry with sb" },
      { pl: "śmiertelnie się nudzić", de: "be bored to death" },
      { pl: "lubić kogoś/coś", de: "be fond of sb/sth" },
      { pl: "być dobrym w czymś", de: "be good at sth" },
      { pl: "być złym w czymś", de: "be bad at sth" },
      { pl: "być zainteresowanym czymś", de: "be interested in sth" },
      { pl: "być beznadziejnym w czymś", de: "be useless at sth" },
      { pl: "martiwć się czymś", de: "be worried about sth" },
      { pl: "nalezec od kogoś/czegoś", de: "belong to sb/sth" },
      { pl: "obgryzać paznokcie", de: "bite your nails" },
      { pl: "mrugać oczami", de: "blink" },
      { pl: "zmienić zdanie", de: "change your mind" },
      { pl: "skrzyzować ramiona", de: "cross your arms" },
      { pl: "ukrywać swoje uczucia", de: "hide your feelings" },
      { pl: "nie okazywac uczuć", de: "hide your feelings" },
      { pl: "zdrowie psychiczne", de: "mental health" },
      { pl: "bułka z masłem", de: "it's a piece of cake" },
      { pl: "wprowadzać kogoś w dobry nastrój", de: "put sb in a good mood" },
      { pl: "wprowadzać kogoś w zły nastrój", de: "put sb in a bad mood" },
      { pl: "poczucie humoru", de: "sense of humour" },
      { pl: "stukać palcami", de: "snap your fingers" },
      { pl: "wzruszać ramionami", de: "shrug your shoulders" },
      { pl: "gryźć się wargę", de: "bite your lip" },
    ]
  }
]

const ZDANIA76 = [
  {
    name: "[8 klasa] Niem Paź 2025 – Moduł 10 (str. 52–55, skrócone zdania)",
    lang: 'de',
    zdania: [
      // Strona 52
      { pl: "Samochody zanieczyszczają środowisko.", de: "Autos verschmutzen die Umwelt." },
      { pl: "Fabryki produkują dym i kurz.", de: "Fabriken produzieren Rauch und Staub." },
      { pl: "Na wysypisku leżą śmieci.", de: "Auf der Mülldeponie liegt Abfall." },
      { pl: "Plastikowe torby szkodzą naturze.", de: "Plastiktüten schaden der Natur." },
      { pl: "Puszki są recyklingowane.", de: "Aluminiumdosen sind recycelbar." },
      { pl: "Kubki papierowe lądują w śmieciach.", de: "Pappbecher landen im Müll." },

      // Strona 53
      { pl: "Mama odwozi cię autem?", de: "Bringt dich deine Mutter mit dem Auto?" },
      { pl: "Korzystasz z autobusu lub tramwaju?", de: "Benutzt du Bus oder Straßenbahn?" },
      { pl: "Kupujesz produkty bio?", de: "Kaufst du Bioprodukte?" },
      { pl: "Wyrzucasz śmieci na ziemię?", de: "Wirfst du Abfälle auf den Boden?" },
      { pl: "Jak ciepło jest zimą w pokoju?", de: "Wie warm ist dein Zimmer im Winter?" },
      { pl: "Znasz efekt cieplarniany?", de: "Kennst du den Treibhauseffekt?" },
      { pl: "Jak długo bierzesz prysznic?", de: "Wie lange duschst du?" },
      { pl: "Kupujesz napoje w plastiku?", de: "Kaufst du Getränke in Plastikflaschen?" },
      { pl: "Wiesz co robi Greenpeace?", de: "Weißt du was Greenpeace tut?" },
      { pl: "Zostawiasz PC na stand-by?", de: "Lässt du den PC auf Stand-by?" },

      // Strona 54
      { pl: "Frau Malin bierze koszyk.", de: "Frau Malin nimmt einen Korb." },
      { pl: "Herr Malin jeździ autobusem.", de: "Herr Malin fährt mit dem Bus." },
      { pl: "Tina segreguje śmieci.", de: "Tina trennt den Müll." },
      { pl: "Stefan oddaje baterie.", de: "Stefan bringt Batterien." },

      // Strona 55
      { pl: "Reporterka pyta czy oni segregują śmieci.", de: "Die Reporterin fragt ob sie Müll trennen." },
      { pl: "Ona pyta co oni oszczędzają.", de: "Sie fragt was sie sparen." },
      { pl: "Reporterka pyta dlaczego kupują bio.", de: "Die Reporterin fragt warum sie Bioprodukte kaufen." },
      { pl: "Ona pyta czy zostawiają światło.", de: "Sie fragt ob sie das Licht brennen lassen." },
      { pl: "Reporterka pyta gdzie mama kupuje owoce.", de: "Die Reporterin fragt wo die Mutter Obst kauft." },

  
      { de: "die Abgase", pl: "spaliny" },
      { de: "der Rauch", pl: "dym" },
      { de: "der Staub", pl: "kurz" },
      { de: "die Mülldeponie", pl: "wysypisko" },
      { de: "die Plastiktüte", pl: "plastikowa torba" },
      { de: "die Plastikflasche", pl: "butelka plastikowa" },
      { de: "die Glasflasche", pl: "butelka szklana" },
      { de: "der Pappbecher", pl: "kubek papierowy" },
      { de: "die Dose", pl: "puszka" },
      { de: "der Karton", pl: "karton" },

      // Strona 53
      { de: "das Auto", pl: "samochód" },
      { de: "öffentliche Verkehrsmittel", pl: "transport publiczny" },
      { de: "die Bioprodukte", pl: "produkty ekologiczne" },
      { de: "der Abfall", pl: "odpad" },
      { de: "der Eimer", pl: "kosz, wiadro" },
      { de: "die Heizung", pl: "ogrzewanie" },
      { de: "der Treibhauseffekt", pl: "efekt cieplarniany" },
      { de: "die Dusche", pl: "prysznic" },
      { de: "Greenpeace", pl: "Greenpeace" },
      { de: "der PC", pl: "komputer" },

      // Strona 54
      { de: "der Korb", pl: "koszyk" },
      { de: "die Arbeit", pl: "praca" },
      { de: "der Bus", pl: "autobus" },
      { de: "die Straßenbahn", pl: "tramwaj" },
      { de: "der Müll", pl: "śmieci" },
      { de: "die Batterie", pl: "bateria" },
      { de: "die Sammelstelle", pl: "punkt zbiórki" },
      { de: "das Recyclingpapier", pl: "papier z recyklingu" },

      // Strona 55
      { de: "trennen", pl: "segregować" },
      { de: "das Wasser", pl: "woda" },
      { de: "sparen", pl: "oszczędzać" },
      { de: "warum", pl: "dlaczego" },
      { de: "das Licht", pl: "światło" },
      { de: "brennen lassen", pl: "zostawiać zapalone" },
      { de: "die Mutter", pl: "mama" },
      { de: "das Obst", pl: "owoce" },
      { de: "das Gemüse", pl: "warzywa" },

      { pl: "Tina jest świadoma ekologicznie.", de: "Tina ist umweltbewusst." },
      { pl: "Jem pizzę na papierowym talerzu.", de: "Ich esse Pizza auf einem Pappteller." },
      { pl: "To nie jest całkiem prawda.", de: "Das ist nicht ganz wahr." },
      { pl: "Hałas mnie denerwuje.", de: "Der Lärm nervt mich." },
      { pl: "Warzywa są zdrowsze niż fast food.", de: "Gemüse ist gesunder als Fast Food." },

      { de: "umweltbewusst", pl: "świadomy ekologicznie" },
      { de: "nicht ganz", pl: "nie całkiem" },
      { de: "nerven", pl: "denerwować" },
      { de: "gesunder", pl: "zdrowszy" }
    ]
  }
]

const ZDANIA77 = [
  {
    name: "[8 klasa] Ang - Dom i meble",
    lang: 'en',
    zdania: [
      // Części domu
      { pl: "strych, poddasze", de: "attic" },
      { pl: "piwnica", de: "basement" },
      { pl: "łazienka", de: "bathroom" },
      { pl: "sypialnia", de: "bedroom" },
      { pl: "sufit", de: "ceiling" },
      { pl: "komin", de: "chimney" },
      { pl: "jadalnia", de: "dining room" },
      { pl: "na dole (domu)", de: "downstairs" },
      { pl: "podjazd", de: "driveway" },
      { pl: "ogrodzenie, płot", de: "fence" },
      { pl: "podłoga, piętro", de: "floor" },
      { pl: "garaż", de: "garage" },
      { pl: "parter", de: "ground floor" },
      { pl: "przedpokój", de: "hall" },
      { pl: "domofon", de: "intercom" },
      { pl: "kuchnia", de: "kitchen" },
      { pl: "trawnik", de: "lawn" },
      { pl: "winda", de: "lift" },
      { pl: "salon", de: "living room" },
      { pl: "dach", de: "roof" },
      { pl: "schody", de: "stairs" },
      { pl: "gabinet, pokój do pracy", de: "study" },
      { pl: "taras", de: "terrace" },
      { pl: "toaleta", de: "toilet" },
      { pl: "na górze", de: "upstairs" },
      { pl: "ściana, mur", de: "wall" },

      // Wyposażenie i elementy wystroju
      { pl: "klimatyzacja", de: "air conditioning" },
      { pl: "żaluzje", de: "blinds" },
      { pl: "półka (na książki)", de: "bookshelf" },
      { pl: "dywan", de: "carpet" },
      { pl: "centralne ogrzewanie", de: "central heating" },
      { pl: "zasłony, firanki", de: "curtains" },
      { pl: "szuflada", de: "drawer" },
      { pl: "wykładzina dywanowa", de: "fitted carpet" },
      { pl: "meble", de: "furniture" },
      { pl: "obraz", de: "painting" },
      { pl: "plakat", de: "poster" },
      { pl: "kaloryfer", de: "radiator" },
      { pl: "tapeta", de: "wallpaper" },
      { pl: "parapet", de: "windowsill" },

      // Meble
      { pl: "budzik", de: "alarm clock" },
      { pl: "fotel", de: "armchair" },
      { pl: "stolik nocny", de: "bedside table" },
      { pl: "koc", de: "blanket" },
      { pl: "biblioteczka", de: "bookcase" },
      { pl: "komoda", de: "chest of drawers" },
      { pl: "wieszak", de: "coat hanger" },
      { pl: "stolik kawowy", de: "coffee table" },
      { pl: "poduszka ozdobna", de: "cushion" },
      { pl: "biurko", de: "desk" },
      { pl: "kołdra", de: "duvet" },
      { pl: "kominek", de: "fireplace" },
      { pl: "poduszka do spania", de: "pillow" },
      { pl: "roślina", de: "plant" },
      { pl: "dywanik", de: "rug" },
      { pl: "kanapa", de: "sofa" },
      { pl: "szafa", de: "wardrobe" },

      // Kuchnia
      { pl: "kuchenka", de: "cooker" },
      { pl: "szafka", de: "cupboard" },
      { pl: "zmywarka", de: "dishwasher" },
      { pl: "lodówka", de: "fridge" },
      { pl: "patelnia", de: "frying pan" },
      { pl: "czajnik", de: "kettle" },
      { pl: "kubek", de: "mug" },
      { pl: "piekarnik", de: "oven" },
      { pl: "rondel", de: "pan" },
      { pl: "talerz", de: "plate" },
      { pl: "garnek", de: "pot" },
      { pl: "zlew", de: "sink" },
      { pl: "kosz na śmieci", de: "waste bin" },

      // Łazienka
      { pl: "wanna", de: "bath" },
      { pl: "suszarka", de: "hairdryer" },
      { pl: "lustro", de: "mirror" },
      { pl: "prysznic", de: "shower" },
      { pl: "kran", de: "tap" },
      { pl: "sedes", de: "toilet" },
      { pl: "ręcznik", de: "towel" },
      { pl: "umywalka", de: "washbasin" },
      { pl: "pralka", de: "washing machine" },

      // Przymiotniki
      { pl: "czysty", de: "clean" },
      { pl: "wygodny", de: "comfortable" },
      { pl: "przytulny", de: "cosy" },
      { pl: "pomalowany, ozdobiony", de: "decorated" },
      { pl: "pusty", de: "empty" },
      { pl: "zabawnie/dziwnie wyglądający", de: "funny-looking" },
      { pl: "umeblowany", de: "furnished" },
      { pl: "olbrzymi, wielki", de: "huge" },
      { pl: "jasny", de: "light" },
      { pl: "luksusowy", de: "luxurious" },
      { pl: "nieuporządkowany", de: "messy" },
      { pl: "nieuporządkowany", de: "untidy" },
      { pl: "nowoczesny", de: "modern" },
      { pl: "staromodny", de: "old-fashioned" },
      { pl: "przyjemny", de: "pleasant" },
      { pl: "niechlujny, brudny", de: "scruffy" },
      { pl: "elegancki", de: "smart" },
      { pl: "przestronny", de: "spacious" },
      { pl: "kamienny", de: "stone" },
      { pl: "słoneczny", de: "sunny" },
      { pl: "schludny, posprzątany", de: "tidy" },
      { pl: "maleńki", de: "tiny" },
      { pl: "brzydki", de: "ugly" },
      { pl: "niezwykły", de: "unusual" },
      { pl: "dobrze wyposażony", de: "well-equipped" },
      { pl: "drewniany", de: "wooden" },

      // Otoczenie i lokalizacja
      { pl: "dogodny, wygodny", de: "convenient" },
      { pl: "zatłoczony", de: "crowded" },
      { pl: "niebezpieczny", de: "dangerous" },
      { pl: "tętniący życiem", de: "lively" },
      { pl: "hałaśliwy", de: "noisy" },
      { pl: "spokojny", de: "peaceful" },
      { pl: "malowniczy", de: "picturesque" },
      { pl: "zanieczyszczony", de: "polluted" },
      { pl: "cichy", de: "quiet" },
      { pl: "bezpieczny", de: "safe" },

      // Przyimki miejsca
      { pl: "nad", de: "above" },
      { pl: "nad", de: "over" },
      { pl: "z tyłu", de: "at the back" },
      { pl: "z przodu", de: "at the front" },
      { pl: "za", de: "behind" },
      { pl: "pomiędzy", de: "between" },
      { pl: "przed", de: "in front of" },
      { pl: "w rogu", de: "in the corner" },
      { pl: "pośrodku", de: "in the middle" },
      { pl: "wewnątrz", de: "inside" },
      { pl: "blisko", de: "near" },
      { pl: "obok, przy", de: "next to" },
      { pl: "po prawej", de: "on the right" },
      { pl: "po lewej", de: "on the left" },
      { pl: "na prawo od", de: "to the right of" },
      { pl: "na lewo od", de: "to the left of" },
      { pl: "naprzeciwko", de: "opposite" },
      { pl: "na zewnątrz", de: "outside" },
      { pl: "pod", de: "under" },

      // Rodzaje domów
      { pl: "mieszkanie", de: "apartment" },
      { pl: "mieszkanie", de: "flat" },
      { pl: "blok mieszkalny", de: "apartment block" },
      { pl: "domek na wsi", de: "cottage" },
      { pl: "dom jednorodzinny", de: "detached house" },
      { pl: "akademik, internat", de: "hall of residence" },
      { pl: "domek letniskowy", de: "holiday home" },
      { pl: "zabytkowa rezydencja", de: "stately home" },
      { pl: "dom szeregowy", de: "terraced house" },

      // Lokalizacja
      { pl: "teren, okolica", de: "area" },
      { pl: "nad jeziorem", de: "by the lake" },
      { pl: "nad rzeką", de: "by the river" },
      { pl: "nad morzem", de: "by the sea" },
      { pl: "blisko czegoś", de: "close to sth" },
      { pl: "daleko od czegoś", de: "far from sth" },
      { pl: "w hałaśliwej dzielnicy", de: "in a noisy district" },
      { pl: "w cichej okolicy", de: "in a quiet neighbourhood" },
      { pl: "w stolicy", de: "in the capital city" },
      { pl: "na wsi", de: "in the country" },
      { pl: "na wsi", de: "in the countryside" },
      { pl: "w centrum", de: "in the heart of" },
      { pl: "na głównej ulicy", de: "in the main street" },
      { pl: "w górach", de: "in the mountains" },
      { pl: "na przedmieściach", de: "in the suburbs" },
      { pl: "w centrum małego miasta", de: "in the town centre" },
      { pl: "w centrum dużego miasta", de: "in the city centre" },
      { pl: "umieszczony, położony", de: "located" },
      { pl: "nieopodal", de: "nearby" },
      { pl: "na plaży", de: "on the beach" },
      { pl: "na granicy", de: "on the border" },
      { pl: "z widokiem na rzekę", de: "overlooking the river" },
      { pl: "wieś, wioska", de: "village" }
    ]
  }
];



export { ZDANIA70, ZDANIA71, ZDANIA73, ZDANIA74, ZDANIA75, ZDANIA76, ZDANIA77 };
